import { useAppSelector } from '@hooks/reduxHooks';
import { baseErrorHandler } from '@queries/baseErrorHandler';
import { showMessage } from '@queries/showMessage';
import { $api } from '@service/RequestService';
import { useMutation, useQueryClient } from 'react-query';

import { queryKeys } from '../constants';
import { DashboardUpdateModel } from '../models';

export function useUpdateDashboard() {
  const qc = useQueryClient();
  const activeDashboard = useAppSelector(({ dashboardReducer }) => dashboardReducer.activeDashboard);

  return useMutation({
    mutationFn: async (payload: DashboardUpdateModel | undefined) => {
      const { data } = await $api.patch('/v1/dashboard/update', [
        { ...(payload || {}), name: payload?.name || activeDashboard?.name }
      ]);

      return data;
    },
    onSuccess: async res => {
      showMessage(res.message, true);

      await qc.invalidateQueries({
        queryKey: [queryKeys.DASHBOARD_ID]
      });
    },
    onError: baseErrorHandler
  });
}
